import { render } from "./LabelFilterSidebar.vue?vue&type=template&id=88a36a22&scoped=true&ts=true"
import script from "./LabelFilterSidebar.vue?vue&type=script&lang=ts"
export * from "./LabelFilterSidebar.vue?vue&type=script&lang=ts"

import "./LabelFilterSidebar.vue?vue&type=style&index=0&id=88a36a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a36a22"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
